<template>
  <div class="page">
    <el-card class="card" shadow="always">
      <div class="head">
        <div>
          <div class="title">HR / 面试官 登录</div>
          <div class="sub">原型演示：不接后端，登录后进入面试管理。</div>
        </div>
      </div>

      <el-divider />

      <el-form ref="form" :model="form" :rules="rules" label-position="top" @submit.native.prevent="onSubmit">
        <el-form-item label="工号 / 邮箱" prop="account">
          <el-input v-model.trim="form.account" placeholder="请输入工号或企业邮箱" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model.trim="form.password" type="password" show-password placeholder="请输入密码" />
        </el-form-item>

        <div class="row">
          <el-checkbox v-model="form.remember">记住密码</el-checkbox>
          <el-link type="primary" @click="forget">忘记密码？</el-link>
        </div>

        <div class="btnRow">
          <el-button type="primary" @click="onSubmit">登录</el-button>
          <el-button @click="$router.push('/')">返回首页</el-button>
        </div>
      </el-form>

      <el-alert
        style="margin-top: 14px"
        title="安全提示"
        type="warning"
        :closable="false"
        show-icon
        description="仅在受信任的办公网络和设备上登录；建议启用 SSO/MFA 等安全策略。"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: "InterviewerLogin",
  data() {
    return {
      form: { account: "", password: "", remember: false },
      rules: {
        account: [{ required: true, message: "请输入工号/邮箱", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码至少 6 位", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    forget() {
      this.$alert("上线版本通常会通过企业邮箱 / 统一身份认证重置密码（原型提示）。", "忘记密码", { confirmButtonText: "知道了" });
    },
    onSubmit() {
      this.$refs.form.validate((ok) => {
        if (!ok) return;
        this.$router.push({ path: "/interviewer/dashboard", query: { user: this.form.account } });
      });
    },
  },
};
</script>

<style scoped>
.page {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}
.card {
  width: min(760px, 100%);
  border: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.9);
  color: #111827;
}
.head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.title {
  font-size: 18px;
  font-weight: 900;
}
.sub {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.btnRow {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
</style>

